<template>
	<div>
		<div class="newADcontent">
			<div class="adContent">
				<div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<div class="flex" style="flex-wrap: wrap;">
					<el-form ref="form" label-width="150px" label-position="left">
						<el-form-item label="服务名称">
							<el-input v-model="filter.title" size="small" style="width: 300px;" maxlength="12"
								show-word-limit placeholder="服务名称,不能超过12个字"></el-input>
						</el-form-item>
            <el-form-item label="英文名称">
              <el-input v-model="filter.englishTitle" size="small" style="width: 300px;" placeholder="英文名称"></el-input>
            </el-form-item>
						<el-form-item label="服务类型">
							<el-radio-group v-model="type">
                <el-radio :label="-1">团购优惠</el-radio>
								<el-radio :label="0">剪发服务</el-radio>
								<el-radio :label="1">烫染服务</el-radio>
								<el-radio :label="2">洗吹服务</el-radio>
								<el-radio :label="3">护理服务</el-radio>
                <el-radio :label="4">造型</el-radio>
                <el-radio :label="5">迷你烫</el-radio>
                <el-radio :label="6">健康染发</el-radio>
                <el-radio :label="7">健康烫发</el-radio>
                <el-radio :label="8">洗吹护理</el-radio>
                <el-radio :label="9">美甲</el-radio>
                <el-radio :label="10">接发</el-radio>
                <el-radio :label="11">特惠项目</el-radio>
							</el-radio-group>
						</el-form-item>
<!--            <el-form-item label="服务价格">-->
<!--              <el-input v-model="filter.price" size="small" style="width: 300px;"  maxlength="30" type="number"-->
<!--                        placeholder="请输入价格"></el-input>-->
<!--            </el-form-item>-->
<!--						<el-form-item label="提成">-->
<!--									<el-input v-model="filter.title" size="small" style="width: 100px;" ></el-input>元-->
<!--								</el-form-item>-->
<!--						<el-form-item label="业绩">-->
<!--							<el-input v-model="filter.commission" size="small" style="width: 100px;"-->
<!--								placeholder="未填写业绩"></el-input> 元-->
<!--						</el-form-item>-->
						<el-form-item label="排队标识">
							<el-input v-model="filter.letter" size="small" style="width: 100px;"></el-input>
						</el-form-item>
<!--						<el-form-item label="男士服务时长">-->
<!--							<el-input v-model="filter.serviceManTime" size="small" style="width: 100px;"></el-input>分-->
<!--						</el-form-item>-->
<!--						<el-form-item label="女士服务时长">-->
<!--							<el-input v-model="filter.serviceWomanTime" size="small" style="width: 100px;"></el-input>分-->
<!--						</el-form-item>-->
						<el-form-item label="立即推出/用户端显示">
              <el-radio v-model="filter.nowIntroduction" label="0">是</el-radio>
              <el-radio v-model="filter.nowIntroduction" label="1">否</el-radio>
						</el-form-item>
						<el-form-item label="描述服务">
							<el-input v-model="filter.msg" style="width: 300px; margin-bottom: 60px;" maxlength="30"
								type="textarea" show-word-limit placeholder="请输入服务描述" rows="5">
							</el-input>
						</el-form-item>
						<el-form-item>
							<div>
								<el-button @click="goback">取消</el-button>
								<el-button type="primary" style="margin-left: 20px;" @click="add">保存</el-button>
<!--								<el-button type="primary" style="margin-left: 20px;"-->
<!--									@click="addDialog()">添加规格</el-button>-->
							</div>
						</el-form-item>
					</el-form>
					<div v-if="parentSpec.length>0">
						<div style="margin: 10px;" v-for="item in parentSpec" class="flex">
							<div style="border:1px solid #8C939D;padding: 10px; ">
								<div class="flex divBottom">
									<div class="flex divTitle">规格名:</div>
									<el-input class="divInput" v-model="item.details" clearable placeholder="输入规格名称" />
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">加收价格:</div>
									<el-input-number :precision="2" :min="0" v-model="item.price" size="small"
										placeholder="价格" class="inputNumber"></el-input-number>
									<div v-if="item.title.substring(0,4)=='http'">
										<upload class="el-tabs-pane-upload" ref="sss" style="margin-left: 20px;"
											v-model="item.title" />
									</div>
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">规格说明:</div>
									<el-input class="divInput" v-model="item.title" clearable placeholder="输入规格说明" />
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">排序:</div>
									<el-input class="divInput" v-model.number="item.sort" clearable
										placeholder="输入序号" />
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">状态:</div>
									<el-radio-group v-model="item.status">
										<el-radio :label="0">下架</el-radio>
										<el-radio :label="1">上架</el-radio>
									</el-radio-group>
								</div>
								<div class="flex divBottom">
									<div class="flex divBottom">
										<div class="flex divTitle">店铺列表:</div>
										<el-input type="text" class="divInput" v-model="item.storeList" clearable
											placeholder="输入店铺ID,英文逗号隔开" />
									</div>
								</div>
								<div class="flex" style="margin-top: 10px;">
									<el-button type="danger" @click="delSpec(item)">删除</el-button>
									<el-button type="primary" @click="addOrUpdateSpec(item)">保存</el-button>
									<el-button @click="addDialog(item.id)" type="primary"
										style="display: block;">添加子规格</el-button>
								</div>
								<!-- 子规格 -->
								<div class="flex">
									<div v-for="item1 in list" v-if="item1.parentId==item.id"
										style="border:3px solid #a6cfff;margin: 10px; padding: 10px;">
										<div class="flex divBottom">
											<div class="flex divTitle">规格名称:</div>
											<el-input class="divInput" v-model="item1.details"
												clearableplaceholder="输入规格名称" />
										</div>
										<div class="flex divBottom">
											<div class="flex divTitle">加收价格:</div>
											<el-input-number :precision="2" :min="0" v-model="item1.price"
												placeholder="价格" class="inputNumber"></el-input-number>
											<div v-if="item1.title.substring(0,4)=='http'">
												<upload class="el-tabs-pane-upload" ref="sss" style="margin-left: 20px;"
													v-model="item1.title" />
											</div>
										</div>
										<div class="flex divBottom">
											<div class="flex divTitle">规格说明:</div>
											<el-input class="divInput" v-model="item1.title" clearable
												placeholder="输入规格说明" />
										</div>
										<div class="flex divBottom">
											<div class="flex divTitle">排序:</div>
											<el-input class="divInput" v-model.number="item1.sort" clearable
												placeholder="输入序号" />
										</div>
										<div class="flex divBottom">
											<div class="flex divTitle">状态:</div>
											<el-radio-group v-model="item1.status">
												<el-radio :label="0">下架</el-radio>
												<el-radio :label="1">上架</el-radio>
											</el-radio-group>
										</div>
										<div class="flex divBottom">
											<div class="flex divTitle">店铺列表:</div>
											<el-input type="text" class="divInput" v-model="item1.storeList" clearable
												placeholder="输入店铺ID,英文逗号隔开" />
										</div>
										<div class="flex" style="margin-top: 10px;margin-left: 40%;">
											<el-button type="info" size="small" @click="delSpec(item1)">删除</el-button>
											<el-button type="info" size="small"
												@click="addOrUpdateSpec(item1)">保存</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else>
						<div class="flex">
							<div v-for="item1 in list" style="border:3px solid #a6cfff;margin: 10px; padding: 10px;">
								<div class="flex divBottom">
									<div class="flex divTitle">规格名称:</div>
									<el-input class="divInput" v-model="item1.details" clearable placeholder="输入规格名称" />
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">加收价格:</div>
									<el-input-number :precision="2" :min="0" v-model="item1.price" placeholder="价格"
										class="inputNumber"></el-input-number>
									<div v-if="item1.title.substring(0,4)=='http'">
										<upload class="el-tabs-pane-upload" ref="sss" style="margin-left: 20px;"
											v-model="item1.title" />
									</div>
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">规格说明:</div>
									<el-input class="divInput" v-model="item1.title" clearable placeholder="输入规格说明" />
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">排序:</div>
									<el-input class="divInput" v-model.number="item1.sort" clearable
										placeholder="输入序号" />
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">状态:</div>
									<el-radio-group v-model="item1.status">
										<el-radio :label="0">下架</el-radio>
										<el-radio :label="1">上架</el-radio>
									</el-radio-group>
								</div>
								<div class="flex divBottom">
									<div class="flex divTitle">店铺列表:</div>
									<el-input type="text" class="divInput" v-model="item1.storeList" clearable
										placeholder="输入店铺ID,英文逗号隔开" />
								</div>
								<div class="flex" style="margin-top: 10px;margin-left: 40%;">
									<el-button type="info" size="small" @click="delSpec(item1)">删除</el-button>
									<el-button type="info" size="small" @click="addOrUpdateSpec(item1)">保存</el-button>
									<el-button @click="addDialog(item1.id)" type="primary"
										style="display: block;">添加子规格</el-button>
								</div>
							</div>
						</div>
					</div>
					<!-- 弹窗添加规格 -->
					<el-dialog :visible.sync="addShow" width="30%">
						<div class="flex divBottom">
							<div class="flex divTitle">规格名:</div>
							<el-input class="divInput" v-model="addData.details" clearable placeholder="输入规格名称" />
						</div>
						<div class="flex divBottom">
							<div class="flex divTitle">加收价格:</div>
							<el-input-number :precision="2" :min="0" v-model="addData.price" size="small"
								placeholder="价格" class="inputNumber"></el-input-number>
						</div>
						<div class="flex divBottom">
							<div class="flex divTitle">规格说明:</div>
							<el-input class="divInput" v-model="addData.title" clearable placeholder="输入规格说明\图片链接" />
						</div>
						<div class="flex divBottom">
							<div class="flex divTitle">排序:</div>
							<el-input class="divInput" v-model.number="addData.sort" clearable placeholder="输入序号" />
						</div>
						<div class="flex divBottom">
							<div class="flex divTitle">状态:</div>
							<el-radio-group v-model="addData.status">
								<el-radio :label="0">下架</el-radio>
								<el-radio :label="1">上架</el-radio>
							</el-radio-group>
						</div>
						<div class="flex divBottom">
							<div class="flex divBottom">
								<div class="flex divTitle">店铺列表:</div>
								<el-input type="text" class="divInput" v-model="addData.storeList" clearable
									placeholder="输入店铺ID,英文逗号隔开" />
							</div>
						</div>
						<div class="flex" style="margin-top: 10px;margin-left: 44%;">
							<el-button type="primary" @click="addOrUpdateSpec(addData)">保存</el-button>
						</div>
					</el-dialog>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload";
	export default {
		components: {
			upload
		},
		data() {
			return {
				filter: {
					title: "",
          englishTitle: "",
					price: "", //价格
					commission: "", //业绩
					nowIntroduction: "",
					showTime: "",
					msg: "",
					type: 0,
					serviceWomanTime:10,
					serviceManTime:10,
					letter: undefined,
				},
				useLetter: [], //标识字符
				list: [], //规格列表
				parentSpec: [], //父类规格列表
				type: 0,
				addShow: false, //父/子规格弹窗
				addData: {
					status: 1, //默认选择上架
				},
			}
		},
		mounted() {
			if (this.$route.query.id) {
				this.getSpec(this.$route.query.id)
				this.filter.id = this.$route.query.id
				var arr = {
					pageNum: 1,
					pageSize: 99999
				}
				this.$http.post("dhaircut/findDhaircutService", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == 200) {
						let a = res.body.data.records
						for (let i in a) {
							if (a[i].id == this.$route.query.id) {
								this.filter.title = a[i].title
                this.filter.englishTitle = a[i].englishTitle
								this.filter.price = a[i].price
								this.filter.commission = a[i].commission
								this.filter.serviceWomanTime = a[i].serviceWomanTime
								this.filter.serviceManTime = a[i].serviceManTime
								this.type = this.filter.type = a[i].type
								this.filter.letter = a[i].letter
								this.useLetter.push(this.filter.letter)
								this.filter.nowIntroduction = a[i].nowIntroduction.toString()
								if (this.filter.nowIntroduction == 1) {
									this.filter.showTime = a[i].showTime
								}
								this.filter.msg = a[i].msg
							}
						}
					} else {
						this.$message.error(res.body.msg)
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			}
			this.getLetter()
		},
		filters: {
			statusFormat(val) {
				switch (val) {
					case 0:
						return "下架";
					case 1:
						return "上架";
				}
			}
		},
		methods: {
			// 返回上一级
			goback() {
				this.$router.go(-1)
			},
			//添加服务
			add() {
				this.filter.type = this.type
				this.$http.post("dhaircut/saveOrUpdate", JSON.stringify(this.filter)).then(function(res) {
					if (res.body.code == 200) {
						if (this.$route.query.id) {
							this.$message.success("修改成功")
						} else {
							this.$message.success("添加成功")
						}
						this.$router.go(-1)
					} else {
						this.$message.error(res.body.msg)
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			getLetter() {
				let letterList = [];
				for (var i = 65; i < 91; i++) {
					letterList.push(String.fromCharCode(i));
				}
				this.$http.get("dhaircut/useLetter").then(res => {
					let data = res.body.data.toString();
					letterList.map(b => {
						if (data.indexOf(b) == -1) {
							this.useLetter.push(b);
						}
					})
					if (!this.filter.id) {
						this.filter.letter = this.useLetter[0]
					}
				})
			},
			getSpec(haircutServiceId) {
				this.$http.get("dHaircutServiceSpec/listByHaircutServiceId?haircutServiceId=" + haircutServiceId).then(
					res => {
						this.list = res.data.data
					})
				this.$http.get("dHaircutServiceSpec/parentSpecList?haircutServiceId=" + haircutServiceId).then(res => {
					this.parentSpec = res.data.data
				})
			},
			//打开添加规格弹窗 1父规格 2子规格
			addDialog(id) {
				this.addData = {}
				this.addShow = true
				if (id) {
					this.addData.parentId = id
				} else {
					this.addData.parentId = 0
				}
				this.addData.haircutServiceId = this.$route.query.id
			},
			// 添加/编辑规格，父子共用
			addOrUpdateSpec(data) {
				this.$http.post("dHaircutServiceSpec/addOrUpdateSpec", data).then(res => {
					if (res.body.code == 200) {
						this.$message.success("修改成功");
						this.getSpec(this.$route.query.id)
					} else {
						this.$message.error(res.body.msg);
					}
					this.addShow = false
				});
			},
			//删除规格，父子共用
			delSpec(item) {
				this.$confirm('此操作将永久删除规格： “' + item.details + '” , 是否继续?', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("dHaircutServiceSpec/delSpec?id=" + item.id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("已删除");
							this.getSpec(this.$route.query.id)
						} else {
							this.$message.error(res.body.msg);
						}
					});
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.flex {
		display: flex;
	}

	.divBottom {
		margin-bottom: 10px;
	}

	.divTitle {
		width: 90px;
		text-align: center;
	}

	.divTop {
		margin-top: 10px;
	}

	.divInput {
		width: 330px;
		margin-right: 10px;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.storelist {
		ul {
			li {
				margin-top: 10px;
				line-height: 1.3;
				display: flex;
				width: auto;

				p {
					width: 8px;
					height: 8px;
					margin-right: 8px;
					border-radius: 50%;
					background-color: black;
					margin-top: 5px;
				}

				div {
					display: none;
					cursor: pointer;
					margin-left: 10px;
					width: 15px;
					height: 15px;
					background-color: red;
					color: white;
					border-radius: 50%;
					text-align: center;
					line-height: 15px;
				}

				&:hover {
					div {
						display: block;
					}
				}
			}
		}
	}

	.el-tabs-pane-upload {
		width: 40px;
		height: 40px;
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}

	.add {
		border: 1px dashed #999B9C;
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 3px;
		padding-bottom: 3px;
		cursor: pointer;
		color: #999B9C;
	}

	/deep/ .tabelContent .el-checkbox__label {
		display: none;
	}
</style>